export const isBoundary = (ch: string, prev?: string): boolean =>
  ch === '\n' || (ch === ' ' && prev === '.');

export const getFragmentAroundCaret = (
  text: string,
  caret: number
): { fragment: string; start: number; end: number } => {
  let i = caret - 1;
  while (i >= 0 && !isBoundary(text[i], text[i - 1])) {
    i -= 1;
  }
  const start = i + 1;
  const fragment = text.slice(start, caret);
  return { fragment, start, end: caret };
};

export const isSubsequence = (needle: string, hay: string): boolean => {
  if (!needle) return true;
  let i = 0;
  let j = 0;
  while (i < needle.length && j < hay.length) {
    if (needle[i] === hay[j]) i += 1;
    j += 1;
  }
  return i === needle.length;
};
